import React from 'react';

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorId: '',
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const errorId = `PERIFA-${Date.now().toString(36).toUpperCase()}`;
    this.setState({ errorId });

    if (process.env.NODE_ENV !== 'production') {
      // Keep development failures visible without exposing stack traces in production UI.
      console.error('[Perifa Pro] Erro inesperado no painel', { errorId, error, errorInfo });
    }
  }

  handleReload = () => {
    if (typeof window !== 'undefined' && window.location) {
      window.location.reload();
    }
  };

  render() {
    const { hasError, errorId } = this.state;
    const { children } = this.props;

    if (!hasError) {
      return children;
    }

    return (
      <main className="app-error-boundary" role="alert">
        <section className="app-error-card" aria-labelledby="app-error-title">
          <span className="app-error-mark" aria-hidden="true">P</span>
          <p className="app-error-eyebrow">Perifa Pro</p>
          <h1 id="app-error-title">Nao foi possivel carregar esta tela</h1>
          <p>
            A conexao do painel foi preservada. Recarregue a pagina para tentar
            novamente sem criar outra conta ou perder o acesso atual.
          </p>
          {errorId ? <small>Codigo de suporte: {errorId}</small> : null}
          <div className="app-error-actions">
            <button type="button" className="app-error-primary" onClick={this.handleReload}>
              Tentar novamente
            </button>
            <a className="app-error-link" href="/admin">
              Voltar ao painel
            </a>
          </div>
        </section>
      </main>
    );
  }
}
